var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "landing-header" }, [
    _c("div", { staticClass: "background-fill" }),
    _vm._v(" "),
    _c("div", { staticClass: "header-wrapper" }, [
      _c(
        "div",
        {
          staticClass: "autodesk-logo-parent",
          on: {
            click: function($event) {
              return _vm.navigateHome()
            }
          }
        },
        [_c("div", { staticClass: "autodesk-logo" })]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-145900e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-145900e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SimpleHeader.vue
// module id = null
// module chunks = 